<template>
  <el-row :gutter="20" class="sec_box d2-mt-20" v-loading="loading">
    <template v-if="readData.length != 0">
      <el-col :span="24" v-for="(item, index) in listTextData" :key="index" class="list_item_box" :title="item.Title">
        <i class="el-icon-d-arrow-right"></i>
        <div class="list_item_info" @click="listDetialHandle(item)">
          <p class="list_item_title">{{ item.Subject || item.Title || "-" }}</p>
          <span class="list_item_time">{{ item.CreateTime || "-" }}</span>
        </div>
        <div class="align-right">
          <template v-if="!item.isRead && item.isRead!=false"></template>
          <template v-else><div :class="['list_item_circle', item.isRead ? '' : 'active']"></div></template>
          <div class="list_item_status" v-if="item.ProcessStatus">
            {{ item.ProcessStatus }}
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="align-center mt-20">
        <span class="no_more">没有更多了~</span>
      </el-col>
    </template>
    <template v-else>
      <el-empty></el-empty>
    </template>
    <!--  @submit="" 信箱 提问 -->
    <list-text-detial :listDetialData="listDetialData" v-model="listDetialVisible" @submit="getReadLoad" />
    <!--  @submit="" 任务 -->
    <list-task-detial :listDetialData="listDetialData" :name='checked.name' v-model="listTaskDetialVisible" @submit="getReadLoad" />
  </el-row>
</template>

<script>
  import listTextDetial from "./listTextDetial";
  import listTaskDetial from "./listTaskDetial";
  export default {
    name: "listText",
    components: {
      listTextDetial,
      listTaskDetial,
    },
    data() {
      return {
        listDetialData: {},
        listDetialVisible: false,
        listTaskDetialVisible: false,
        listTextData:[]
      };
    },
    created() {
    },
    mounted() {},
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      readData: {
        type: Array,
        required: false,
        default: () => [],
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
    },
    created() {
      this.setValue();
    },
    watch: {
      readData(val) {
        this.setValue(val)
      }
    },
    methods: {
      setValue(val) {
        this.listTextData=[]
        let array = val ? val : this.readData
        array.forEach(v => {
          if(this.checked.name=='待处理' && v.Type=='主席信箱'){

          }else{
            this.listTextData.push(v)
          }
        });
      },
      listDetialHandle(item) {
        if(this.checked.shortTitle=='主席信箱视图') {  //主席信箱中打开弹出
          this.listDetialVisible = true;
          this.listDetialData = item;
        }else {
          this.listTaskDetialVisible = true;
          this.listDetialData = item;
        }
      },
      getReadLoad() {
        this.$emit("message");
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";
</style>